import { useState } from 'react';
import { FileText, Loader2, Send, CheckCircle, AlertCircle } from 'lucide-react';
import { downloadRelatorio, publicarRelatorio } from '../../services/ticketService';
import { Button } from '../../components/ui/button';

interface RelatorioButtonProps {
  ticketId: string;
  status?: string;
}

export const RelatorioButton = ({ ticketId, status }: RelatorioButtonProps) => {
  const [loading, setLoading] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [published, setPublished] = useState(false);

  const podePublicar = status === 'RESOLVIDO' || status === 'FECHADO';

  const handleDownload = async () => {
    try {
      setLoading(true);
      setError(null);
      await downloadRelatorio(ticketId);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao gerar relatório');
      console.error('Erro ao gerar relatório:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePublicar = async () => {
    try {
      setPublishing(true);
      setError(null);
      await publicarRelatorio(ticketId);
      setPublished(true);
      setTimeout(() => setPublished(false), 3000);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao publicar relatório');
      console.error('Erro ao publicar relatório:', err);
    } finally {
      setPublishing(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        onClick={handleDownload}
        disabled={loading || !podePublicar}
        variant="secondary"
        title={!podePublicar ? 'Só é possível gerar o relatório de um ticket concluído' : undefined}
      >
        {loading ? (
          <>
            <Loader2 className="animate-spin" />
            Gerando PDF...
          </>
        ) : (
          <>
            <FileText />
            Relatório PDF
          </>
        )}
      </Button>

      <Button
        onClick={handlePublicar}
        disabled={publishing || published || !podePublicar}
        variant="secondary"
        title={!podePublicar ? 'Só é possível publicar o relatório de um ticket concluído' : undefined}
      >
        {publishing ? (
          <>
            <Loader2 className="animate-spin" />
            Publicando...
          </>
        ) : published ? (
          <>
            <CheckCircle />
            Publicado no Portal
          </>
        ) : (
          <>
            <Send />
            Publicar no Portal
          </>
        )}
      </Button>

      {error && (
        <div className="flex items-center gap-1 text-sm text-red-600 dark:text-red-400">
          <AlertCircle className="w-4 h-4" />
          {error}
        </div>
      )}
    </div>
  );
};
